import { render } from "./MainViewU19.vue?vue&type=template&id=6340aa9c&scoped=true"
import script from "./MainViewU19.vue?vue&type=script&lang=js"
export * from "./MainViewU19.vue?vue&type=script&lang=js"

import "./MainViewU19.vue?vue&type=style&index=0&id=6340aa9c&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6340aa9c"]])

export default __exports__